import React from 'react';
import { DollarSign, BookOpen, Home, Award } from 'lucide-react';

/**
 * Компонент с параметрами расходов на образование
 */
const ExpensesParametersSection = ({ 
  formData, 
  handleInputChange, 
  errors 
}) => {
  return (
    <div className="mb-6 bg-yellow-50 dark:bg-yellow-900/20 p-4 rounded-lg border border-yellow-200 dark:border-yellow-800">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <DollarSign className="w-5 h-5 mr-2 text-yellow-500" />
        Расходы на образование
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Стоимость обучения в год */}
        <div>
          <label htmlFor="tuitionFeePerYear" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <DollarSign className="w-4 h-4 mr-2 text-yellow-500" />
            Стоимость обучения в год (руб.)
          </label>
          <input
            type="text"
            id="tuitionFeePerYear"
            name="tuitionFeePerYear"
            value={formData.tuitionFeePerYear}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.tuitionFeePerYear ? 'input-error' : ''}`}
            placeholder="Например, 150 000"
          />
          {errors.tuitionFeePerYear && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.tuitionFeePerYear}
            </p>
          )}
          <p className="mt-1 text-xs text-gray-600 dark:text-gray-400">
            Примерная стоимость: гос. вуз - 90-250 тыс. руб., частный - 180-450 тыс. руб., престижный - 300-700 тыс. руб.
          </p>
        </div>

        {/* Расходы на проживание в год */}
        <div>
          <label htmlFor="livingExpensesPerYear" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <Home className="w-4 h-4 mr-2 text-yellow-500" />
            Расходы на проживание в год (руб.)
          </label>
          <input
            type="text"
            id="livingExpensesPerYear"
            name="livingExpensesPerYear"
            value={formData.livingExpensesPerYear}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.livingExpensesPerYear ? 'input-error' : ''}`}
            placeholder="Например, 120 000"
          />
          {errors.livingExpensesPerYear && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.livingExpensesPerYear}
            </p>
          )}
        </div>

        {/* Расходы на учебники и материалы */}
        <div>
          <label htmlFor="booksAndSuppliesPerYear" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <BookOpen className="w-4 h-4 mr-2 text-yellow-500" />
            Учебники и материалы в год (руб.)
          </label>
          <input
            type="text"
            id="booksAndSuppliesPerYear"
            name="booksAndSuppliesPerYear"
            value={formData.booksAndSuppliesPerYear}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.booksAndSuppliesPerYear ? 'input-error' : ''}`}
            placeholder="Например, 25 000"
          />
          {errors.booksAndSuppliesPerYear && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.booksAndSuppliesPerYear}
            </p>
          )}
        </div>

        {/* Ожидаемая стипендия */}
        <div>
          <label htmlFor="scholarshipAmount" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <Award className="w-4 h-4 mr-2 text-yellow-500" />
            Ожидаемая стипендия в месяц (руб.)
          </label>
          <input
            type="text"
            id="scholarshipAmount"
            name="scholarshipAmount"
            value={formData.scholarshipAmount}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.scholarshipAmount ? 'input-error' : ''}`}
            placeholder="Например, 0"
          />
          {errors.scholarshipAmount && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.scholarshipAmount}
            </p>
          )}
          <p className="mt-1 text-xs text-gray-600 dark:text-gray-400">
            Базовая стипендия: 1500-3000 руб., повышенная: 5000-15000 руб.
          </p>
        </div>
      </div>
      
      <div className="mt-4 bg-yellow-100 dark:bg-yellow-900/30 p-3 rounded-lg border border-yellow-200 dark:border-yellow-800">
        <div className="flex items-start">
          <DollarSign className="w-5 h-5 text-yellow-600 dark:text-yellow-400 mr-3 mt-1" />
          <div>
            <h4 className="text-sm font-medium text-yellow-700 dark:text-yellow-300 mb-1">
              О расходах на образование
            </h4>
            <p className="text-xs text-yellow-600 dark:text-yellow-400">
              Помимо платы за обучение, необходимо учитывать расходы на проживание, питание, 
              учебные материалы и транспорт. Стоимость образования в крупных городах, 
              особенно в Москве и Санкт-Петербурге, значительно выше.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExpensesParametersSection;